import { useEffect } from "react";
import { CreateWorkOrderViewModel } from "../../viewmodels/workOrders/CreateWorkOrderViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import CreateNewWorkOrderForm from "../../components/forms/workOrders/CreateNewWorkOrderForm";

function CreateWorkOrder(props) {
  const { addSnackbar, logout } = props;
  const {
    customers,
    getCustomersForDropdown,
    employeeOptions,
    getEmployeesForDropdown,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    createWorkOrderApiCall,
  } = CreateWorkOrderViewModel(logout, addSnackbar);

  useEffect(() => {
    getCustomersForDropdown();
    getEmployeesForDropdown();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              New Work Order
            </h1>
          </div>
          <div className="mt-5">
            <CreateNewWorkOrderForm
              customers={customers}
              employeeOptions={employeeOptions}
              isEdit={false}
              loading={false}
              showErrorModal={showErrorModal}
              workOrder={{}}
              services={[]}
              actionCall={createWorkOrderApiCall}
              setEmptyModelOpen={setEmptyModelOpen}
              addServiceToOrderCall={{}}
              askEditOrderItem={{}}
              removeImageAtIndexCall={(img) => {}}
              uploadNewImageCall={(img) => {}}
              emailInvoice={{}}
              emailWoInProgress={{}}
            />
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateWorkOrder)
);
